import Tag from '../Tag';
import ConsentManager from "../../ConsentManager";

/**
 * ConsentManager.Tag.IFrameTag
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2025-07-11 Added disable() function.
 * @package felixkiesewetter-js/consentmanager
 * @since 5.0.0
 */
class IFrameTag extends Tag
{

    _tagName = 'iframe';

    /**
     * Opt-in iframe tag.
     */
    optIn() :Tag
    {
        this.getConsentManager().enableIFrame(this.getName());
        return super.optIn();
    }

}

export default IFrameTag;
